app.directive('selectSingle', ['$filter', '$timeout', function ($filter, $timeout) {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        require: '?ngModel',
        scope: {
            'title': '@',
            'default': '@',
            'disable': '=',
            'removeTitle': '@',
            'data': '=',
            'classDropdown': '@',
            'jsonData': '=',
            'attrLabel': '@',
            'test': '=ngModel',
            'change': '&ngChange',
            'searchText': '=?searchText',
            'ngChangeSearchtext': '&'
        },
        templateUrl: "application/templates/directives/selectSingle.html",
        link: function (scope, element, attrs, ngModel) {
            if (ngModel) {
                scope.$watch('selectedValue', function (newVal, oldVal) {
                    if (scope.selectedValue !== null) {
                        ngModel.$setViewValue(scope.selectedValue);
                    }
                });
            }
        },
        controller: function ($scope) {
            $scope.selectedValue = null;
            $scope.hideSpan = $scope.default ? true : false;

            $scope.default = $scope.default ? $scope.default : null;

            var height = 40 * ($scope.data ? $scope.data.length : $scope.jsonData.length);
            $scope.config = {
                setHeight: height
            };
            $scope.changeValue = function (value, event) {
                $scope.default = value;
                $scope.hideSpan = $scope.default ? true : false;
            };

            $scope.changeValueSearch = function () {
                $scope['searchText'] = $scope.inputValue;
                if ($scope['ngChangeSearchtext']) {
                    $scope.ngChangeSearchtext();
                }
            };

            $scope.focusSearch = function (event) {
                $(event.currentTarget).closest(".select-single").find("input[type='text']").focus();
            };

            $scope.toggled = function (open) {
                delete $scope.inputValue;
            }
        }
    }
}]);
